import {datadogRum} from '@datadog/browser-rum'

type LogContext = {
  description: string
  source: string
  [key: string]: unknown
}

function toError(input: unknown): Error {
  if (input instanceof Error) {
    const err = new Error(input.message)
    err.name = input.name
    err.stack = input.stack
    return err
  }
  if (input !== null && typeof input === 'object') {
    if ('statusText' in input && typeof input.statusText === 'string') {
      return new Error(input.statusText)
    }
    if ('message' in input && typeof input.message === 'string') {
      return new Error(input.message)
    }
  }
  return new Error(String(input))
}

function error(input: unknown, context: LogContext): void {
  const err = toError(input)
  if (typeof window === 'undefined' || process.env.NODE_ENV !== 'production') {
    console.error(err, context)
  } else {
    datadogRum.addError(err, context)
  }
}

const logger = {error}

export default logger
